export default function isDateInDay(checkDate, dayIn) {
	const checkDateConst = new Date(checkDate);
	const dateInConst = new Date(dayIn);

	return (
		checkDateConst.getDate() === dateInConst.getDate() &&
      checkDateConst.getMonth() === dateInConst.getMonth() &&
      checkDateConst.getFullYear() === dateInConst.getFullYear()
	);
}